<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">{{headerTitle}}</span>
  </div>
  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content" *ngIf="!typeLoading">
  <div class="inputs-block">
    <div class="input-block">
      <div class="input-label">Name:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}" [(ngModel)]="tempModifier.name">
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Affecting Category:</div>

      <div class="email-input-text">
        <p-dropdown [options]="categories" [(ngModel)]="tempModifier.affectingCategory"
                    placeholder="Affecting Category"
                    optionLabel="name" appendTo="body" panelStyleClass="p-modifier-dropdown-panel"
        ></p-dropdown>
      </div>
    </div>

    <ng-container
      *ngIf="tempModifier.affectingCategory?.categoryType !== 'MISC' &&
          tempModifier.affectingCategory?.categoryType !== 'ADDONS'">
      <!--      TO DO Show even if its misc-->

      <div class="input-block">
        <div class="input-label">Categories:</div>

        <div class="email-input-text">
          <p-listbox [options]="categories" [(ngModel)]="tempModifier.owningCategories" [multiple]="true"
                     [checkbox]="true"
                     [showToggleAll]="false" optionLabel="name" [filter]="true"
                     [ngModelOptions]="{standalone: true}" class="p-list-box-block">
          </p-listbox>
        </div>
      </div>

      <div class="input-block" *ngFor="let field of tempModifier.fields; let i = index">
        <div class="input-label">{{field.pricingItemField}}:</div>

        <div class="email-input-text">
          <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}" [(ngModel)]="field.value">
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="tempModifier.affectingCategory?.categoryType === 'MISC' ||
        tempModifier.affectingCategory?.categoryType === 'ADDONS'">
      <div class="input-block">
        <div class="input-label">Preset:</div>

        <div class="email-input-text">
          <p-dropdown [options]="miscPresetsList" [(ngModel)]="chosenPreset" [optionLabel]="'title'"
                      placeholder="Preset" appendTo="body" panelStyleClass="p-modifier-dropdown-panel"
          ></p-dropdown>
        </div>
      </div>
      <div class="input-block"
           *ngIf="chosenPreset.value === 'CUSTOM' || chosenPreset.value === 'HIDE_MISC' || chosenPreset.value === 'INCLUDE_PRICE'">
        <div class="input-label">Misc List:</div>

        <div class="email-input-text">
          <p-listbox [options]="miscList" [(ngModel)]="tempModifier.misc" [multiple]="false" [checkbox]="false"
                     [showToggleAll]="false" optionLabel="name" [filter]="true"
                     [ngModelOptions]="{standalone: true}" class="p-list-box-block">
          </p-listbox>
        </div>
      </div>
    </ng-container>

    <div class="input-block">
      <div class="input-label">Default Checkmark Value:</div>

      <div class="email-input-text">
        <p-inputSwitch class="arrow-input" [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="tempModifier.defaultValue"></p-inputSwitch>
      </div>
    </div>

  </div>

  <div class="save-btn-block">
    <div class="sav-btn-bloock">
      <div class="space-block">
      </div>

      <button mat-button class="save-btn" (click)="saveSub()"
              [disabled]="loadingSpinner || !tempModifier.name || !tempModifier.affectingCategory || !tempModifier.owningCategories?.length"
              tabindex="1" type="submit"
              [ngClass]="{'disabled-button': loadingSpinner || !tempModifier.name || !tempModifier.affectingCategory || !tempModifier.owningCategories?.length}">
        <span *ngIf="!loadingSpinner">{{footerBtnString}}</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>

      <div class="flex-box">
        <button *ngIf="footerBtnString === 'Save'" mat-button class="delete-task-button" (click)="deleteSub()">
          <mat-icon *ngIf="!deleteLoadingSpinner">delete</mat-icon>
          <lib-mini-progress-spinner *ngIf="deleteLoadingSpinner"></lib-mini-progress-spinner>
        </button>
      </div>

    </div>
  </div>
</div>
<div class="loading-spinner-block" *ngIf="typeLoading">
  <lib-progress-spinner></lib-progress-spinner>
</div>
